import { Typography, Button } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { UsersClient, UserWithOrganizationResponseDTO, OrganizationResponseDTO, OrganizationsClient } from '../generated/ApiClient'
import MUIDataTable from "mui-datatables";
import { Link as RouterLink } from 'react-router-dom';
import { UserFriendlyRoleNames } from '../hooks/useIsUserInRoles';
import { useDispatch } from 'react-redux';
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { tableOptions as options } from '../common/Shared'
interface UsersTableData {
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    organization: string;
    status: string;
    azureId: string;
}

export default function Users() {
    const [usersData, setUsersData] = useState<UsersTableData[]>([]);

    const tableOptions = {
        ...options,
        onRowsDelete: ((rowsDeleted: { lookup: any; data: { index: number; dataIndex: number; }[]; }, data: UsersTableData[]) => {
            const selectedIndexs = rowsDeleted.data.map((row) => row.dataIndex);
            const userIds: string[] = selectedIndexs.map((index) => usersData![index].azureId);
            removeUsers(userIds);
        })
    }
    const dispatch = useDispatch()

    const removeUsers = async (azureIds: string[]) => {
        try {
            await Promise.all(azureIds.map((azureId) => removeUser(azureId)));
            dispatch(snackbar.addMessage({ title: "Success", message: `Users successfully removed`, alertType: 'success' }))
            const newUsersData = usersData.filter(x => !azureIds.includes(x.azureId));
            setUsersData(newUsersData);
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }
    const removeUser = async (azureId: string) => {
        try {
            await new UsersClient().delete4(azureId);
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }

    const columns = [
        {
            name: "firstName",
            label: "First Name",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "lastName",
            label: "Last Name",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "email",
            label: "Email",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "role",
            label: "Role",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "organization",
            label: "Organization",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "status",
            label: "Status",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: 'detailsButton',
            label: 'View',
            options: {
                sort: false,
                filter: false,
                customBodyRenderLite: (dataIndex: number) => {
                    const link = `/users/${usersData[dataIndex].azureId}`;
                    return <Button component={RouterLink} variant='contained' size='small' to={link}>View</Button>
                }
            }
        },
    ];

    function toTableData(userData: UserWithOrganizationResponseDTO, orgData: OrganizationResponseDTO[]) {
        let orgName = "";
        const orgforUser = orgData.find(org => org.externalId === userData.organization?.externalId)
        if (orgforUser) {
            orgName = orgforUser.name;
        }
        return {
            firstName: userData.givenName || "",
            lastName: userData.surname || "",
            email: userData.userName || "",
            role: UserFriendlyRoleNames[userData.role.Case],
            organization: orgName || "",
            status: userData.active ? 'Active' : 'Inactive',
            azureId: userData.azureId || ""
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            const usersData = await new UsersClient().getMany3();
            const organizationsData = await new OrganizationsClient().getMany();
            setUsersData(usersData.map(u => toTableData(u, organizationsData)));
        }
        fetchData();
    }, [])

    return (
        <>
            <Typography variant='h4' id="tabelLabel">Members</Typography>
            <MUIDataTable
                title={""}
                data={usersData}
                columns={columns}
                options={tableOptions}
            />
        </>
    )
}